<template>
  <div>
    <v-layout class="mb-3">
      <v-spacer />
      <v-btn :loading="exportation.isLoading" @click="exportData()">
        <i class="fas fa-file-export fa-fw"></i>
        {{ $t('export') }}
      </v-btn>
    </v-layout>

    <v-layout class="mb-3">
      <v-spacer />
      <v-btn color="primary" @click="toggleAdvancedSearch()">
        <v-icon>search</v-icon>
        {{ $t('advanced search') }}
        <v-icon
          :style="
            advancedSearch.isVisible && {
              transform: 'rotate(0.5turn)'
            }
          "
        >
          arrow_drop_down
        </v-icon>
      </v-btn>
    </v-layout>

    <keep-alive>
      <AdvancedSearch
        v-if="advancedSearch.isVisible"
        v-model="advancedSearch.filter"
        class="mb-3"
        @input="
          search()
          resetIntervalSearch()
        "
      />
    </keep-alive>

    <DataTable
      :items="result.items"
      :pagination.sync="result.pagination"
      :loading="result.isLoading"
      @update:pagination="
        ({ page }) => {
          search(page)
          resetIntervalSearch()
        }
      "
      @success:disconnect="
        search(result.pagination.page)
        resetIntervalSearch()
      "
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import XLSX from 'xlsx'
import { getBrokers } from '@/api/assetwise'
import DataTable from './DataTable.vue'
import AdvancedSearch from './AdvancedSearch.vue'

export default {
  name: 'AssetWiseBrokerManagement',
  components: {
    DataTable,
    AdvancedSearch
  },
  data() {
    return {
      advancedSearch: {
        isVisible: false,
        filter: {
          brokerId: '',
          brokerName: '',
          startDate: null,
          endDate: null,
          email: '',
          phone: '',
          team: { value: '', text: this.$t('All') }
        }
      },
      result: {
        isLoading: false,
        items: [],
        pagination: {
          page: 1,
          rowsPerPage: 10,
          totalItems: 0
        }
      },
      exportation: {
        isLoading: false
      },
      intervalId: null
    }
  },
  computed: {
    ...mapState(['selectedBot'])
  },
  async created() {
    this.search()
    this.startIntervalSearch()
  },
  beforeDestroy() {
    this.stopIntervalSearch()
  },
  methods: {
    async fetch(overrideData) {
      const { filter } = this.advancedSearch
      const { pagination } = this.result

      const { data } = await getBrokers({
        page_id: this.selectedBot.pageid,
        date_from: filter.startDate ? dayjs(filter.startDate).format('YYYY-MM-DD') : '',
        date_to: filter.endDate ? dayjs(filter.endDate).format('YYYY-MM-DD') : '',
        agent_name: filter.brokerName ? [filter.brokerName] : [],
        agent_id: filter.brokerId,
        email: filter.email,
        phone: filter.phone,
        team_name: [...(filter.team.value ? [filter.team.text] : [])],
        limit: pagination.rowsPerPage,
        offset: (pagination.page - 1) * pagination.rowsPerPage,
        ...overrideData
      })

      return data
    },
    toggleAdvancedSearch() {
      this.advancedSearch.isVisible = !this.advancedSearch.isVisible
    },
    async search(page = 1) {
      try {
        this.result.isLoading = true

        this.result.pagination = {
          ...this.result.pagination,
          page
        }

        const { data: items, total: totalItems = 0 } = await this.fetch()

        const { rowsPerPage } = this.result.pagination

        Object.assign(this.result, {
          items: items.map((item, index) => ({
            index: (page - 1) * rowsPerPage + index + 1,
            id: `${item.id}-${index}`,
            brokerId: item.broker_no || '',
            brokerName: `${item.firstname || ''} ${item.lastname || ''}`.trim(),
            email: item.email || '',
            phone: item.mobile || '',
            teams: (item.teams || []).map((team) => team.team_name),
            date: item.create_date,
            isConnected: item.is_connect
          })),
          pagination: {
            ...this.result.pagination,
            totalItems
          }
        })
      } catch (error) {
        this.$swal(this.$t('Something went wrong'), undefined, 'error')
        console.error(error)
      } finally {
        this.result.isLoading = false
      }
    },
    async exportData() {
      try {
        this.exportation.isLoading = true

        const { data: items } = await this.fetch({
          limit: Number.MAX_SAFE_INTEGER,
          offset: 0
        })

        const rows = items.map((item, index) => ({
          'No.': index + 1,
          'Broker ID': item.broker_no || '',
          'Broker name': `${item.firstname || ''} ${item.lastname || ''}`.trim(),
          'E-mail': item.email || '',
          Phone: item.mobile || '',
          Team: (item.teams[0] || {}).team_name || '',
          Date: dayjs(item.create_date).format('DD/MM/YYYY')
        }))
        const worksheet = XLSX.utils.json_to_sheet(rows)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Brokers')
        XLSX.writeFile(workbook, 'assetwise-brokers.xlsx')
      } catch (error) {
        this.$swal(this.$t('Something went wrong'), undefined, 'error')
        console.error(error)
      } finally {
        this.exportation.isLoading = false
      }
    },
    startIntervalSearch() {
      this.intervalId = setInterval(() => {
        this.search(this.result.pagination.page)
      }, 10000)
    },
    stopIntervalSearch() {
      clearInterval(this.intervalId)
    },
    resetIntervalSearch() {
      clearInterval(this.intervalId)
      this.startIntervalSearch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/Broker/index.vue